// Common variables and fields that are needed in all queries
const queryTemplateBase = `
    query operationName($first: Int
                        $after: String
                        $name_Icontains: String
                        $definition_Icontains: String
                        $search: String
                        $orderBy: String
                        $favouritedOrTagged: Boolean
                        $favourited: Boolean
                        $tagId: String
                        $metadataTypeIn: String
                        $statusIn: String
                        $itemControlStatusIn: String
                        $showFederated: Boolean
                        $isDeleted: Boolean
                        $collection: String
                        $subcollections: Boolean
                        extraVariablesPartOne
                        ) {
      operationName(first: $first
                    after: $after
                    name_Icontains: $name_Icontains
                    definition_Icontains: $definition_Icontains
                    search: $search
                    orderBy: $orderBy
                    favouritedOrTagged: $favouritedOrTagged
                    favourited: $favourited
                    tagId: $tagId
                    metadataTypeIn: $metadataTypeIn
                    statusIn: $statusIn
                    itemControlStatusIn: $itemControlStatusIn
                    showFederated: $showFederated
                    isDeleted: $isDeleted
                    collection: $collection
                    subcollections: $subcollections
                    extraVariablesPartTwo
                    ) {
        allQsUuid
        totalCount
        pageCount
        pageInfo {
          hasNextPage
        }
        edges{
          node{
            aristotleId
            metadataTypeName
            url
            name
            uuid
            favouriteInfo
            tagInfo
            shortDefinition
            isFederated
            statuses(isCurrent: true){
              stateName
              registrationAuthority{
                name
              }
              registrationDate
            }
            modified
            created
            alternativeNames
            references
            comments
            isDeleted
            userCanDelete
            userCanEdit
            userCanRestore
            isDraft
            extraInformation
          }
        }
      }
    }
`

// Extra variables required for non sandbox items only
const extraVariablesPartOneNonSandbox = `
                        $stewardshipOrganisation: String
                        $workgroupId: String
`

const extraVariablesPartTwoNonSandbox = `
                    stewardshipOrganisation: $stewardshipOrganisation
                    workgroupId: $workgroupId
                    includeSandbox: true
`
// Extra variables required for related metadata search
const extraVariablesPartOneRelated = `
                        $relatedToMetadata: UUID
`

const extraVariablesPartTwoRelated = `
                    relatedToMetadata: $relatedToMetadata
                    includeSandbox: true
`

// Extra variables required for related metadata search with one type
const extraVariablesPartOneRelatedType = `
                        $relatedToMetadata: UUID
                        $relatedToMetadataRelationType: String
`

const extraVariablesPartTwoRelatedType = `
                    includeSandbox: true
                    relatedToMetadata: $relatedToMetadata
                    relatedToMetadataRelationType: $relatedToMetadataRelationType
`

// Extra variables required for sandbox items only
const extraVariablesPartOneSandbox = `
                        $sharedUuid: String
`

const extraVariablesPartTwoSandbox = `
                    sharedUuid: $sharedUuid
`

// Additional information needed based on different metadata types
const dataElementsExtraInformation = `
            dataElementConcept{
                name
            }
            valueDomain{
                name
            }
`

const valueDomainsExtraInformation = `
            dataType{
              name
            }
            unitOfMeasure{
              name
            }
`

const dataElementConceptsExtraInformation = `
            objectClass{
              name
            }
            property{
              name
            }
`

const unitOfMeasuresExtraInformation = `
            measure{
              name
            }
`

const metadataExtraInformation = `
            dataelement{
              dataElementConcept{
                name
              }
              valueDomain{
                name
              }
            }
            valuedomain{
              dataType{
                name
              }
               unitOfMeasure{
                name
              }
            }
            dataelementconcept{
              objectClass{
                name
              }
              property{
                name
              }
            }
            unitofmeasure{
              measure{
                name
              }
            }
`

// General template for Metadata Registry Objects extended from queryTemplateBase
const queryTemplate = queryTemplateBase
    .replace('extraVariablesPartOne', extraVariablesPartOneNonSandbox)
    .replace('extraVariablesPartTwo', extraVariablesPartTwoNonSandbox)

// Query template for other metadata types except `DataElement`, `ValueDomains`, `DataElementConcepts` and `UnitofMeasure`
// These metadata types does not have children, hence, `extraInformation` can be removed
export const queryTemplateGeneric = queryTemplate.replace('extraInformation', '')

// Query based on specific metadata types with their corresponding children
export const queryDataElements = queryTemplate
    .replace(/operationName/g, 'dataElements')
    .replace('extraInformation', dataElementsExtraInformation)

export const queryValueDomains = queryTemplate
    .replace(/operationName/g, 'valueDomains')
    .replace('extraInformation', valueDomainsExtraInformation)

export const queryDataElementConcepts = queryTemplate
    .replace(/operationName/g, 'dataElementConcepts')
    .replace('extraInformation', dataElementConceptsExtraInformation)

export const queryUnitOfMeasures = queryTemplate
    .replace(/operationName/g, 'unitOfMeasures')
    .replace('extraInformation', unitOfMeasuresExtraInformation)

// Query to retrieve a list of all metadata type
export const queryMetadata = queryTemplate
    .replace(/operationName/g, 'metadata')
    .replace('extraInformation', metadataExtraInformation)

// Query to retrieve all sandbox metadata
export const querySandboxMetadata = queryTemplateBase
    .replace(/operationName/g, 'sandboxMetadata')
    .replace('extraInformation', metadataExtraInformation)
    .replace('extraVariablesPartOne', extraVariablesPartOneSandbox)
    .replace('extraVariablesPartTwo', extraVariablesPartTwoSandbox)

// Query to retrieve all related metadata
export const queryRelatedMetadata = queryTemplateBase
    .replace(/operationName/g, 'metadata')
    .replace('extraInformation', metadataExtraInformation)
    .replace('extraVariablesPartOne', extraVariablesPartOneRelated)
    .replace('extraVariablesPartTwo', extraVariablesPartTwoRelated)

// Query to retrieve related metadata of a specific type
export const queryRelatedMetadataByType = queryTemplateBase
    .replace(/operationName/g, 'metadata')
    .replace('extraInformation', metadataExtraInformation)
    .replace('extraVariablesPartOne', extraVariablesPartOneRelatedType)
    .replace('extraVariablesPartTwo', extraVariablesPartTwoRelatedType)
